import styled from '@emotion/styled';
import { ITextProps } from './types';

export const Text = styled.p<ITextProps>`
  padding: 0;
  margin: 0;
`;
